import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { HttpClient } from '@angular/common/http';
import { MatHorizontalStepper } from '@angular/material/stepper';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Snackbar } from 'src/util/snackbar';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ExplorationDTOResponse } from 'src/model/dto/ExplorationDTOResponse';
import { PropertyProvider } from 'src/providers/company/property/property';
import { ExplorationProvider } from 'src/providers/company/exploration/exploration';
import { MemberProvider } from 'src/providers/company/member/member';
import { Certificado } from 'src/model/Certificado';
import { CertificadoProvider } from 'src/providers/certificado/certificadoProvider';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cadastro-inicial-simplificado',
  templateUrl: './cadastro-inicial-simplificado.component.html',
  styleUrls: ['./cadastro-inicial-simplificado.component.scss']
})
export class CadastroInicialSimplificadoComponent implements OnInit, OnDestroy {

  @ViewChild('stepper', { static: false }) stepper!: MatHorizontalStepper;

  companyId: string = "";
  loading: boolean = false;
  registerProperties: boolean = true;
  globalPropertyCounter: number = 0;
  allRegisteredMembers: any[] = [];
  allRegisteredProperties: any[] = [];

  /* ---------------------------
     STEP 1 — UPLOAD DO CERTIFICADO
  ---------------------------- */
  uploadForm = this.fb.group({
    file: [null, Validators.required],
    password: ['', Validators.required]
  });
  selectedFile: File | null = null;
  certPassword = '';
  isDragging = false;
  isProcessing = false;
  certificateBase64 = null;

  /* ---------------------------
     STEP 2 — DADOS CERTIFICADO
  ---------------------------- */
  certData: CertData | null = null;

  /* ---------------------------
     STEP 3 — CONSULTA DFE
  ---------------------------- */
  selectedUf = '43';

  logs: Array<{ type: string; message: string; timestamp: string }> = [];
  progress = 0;
  currentMessage = 'Aguardando...';

  ws$: WebSocketSubject<any> | null = null;
  isConsulting = false;

  consultaResult: ConsultaResult | null = null;


  /* ---------------------------
     STEP 4 e 5 — RESULTADO FINAL
  ---------------------------- */

  allProperties: Inscricao[] = [];
  selectedProperties = new Set<string>();

  ufOptions = [
    { value: '11', label: 'Rondônia (RO)' },
    { value: '12', label: 'Acre (AC)' },
    { value: '13', label: 'Amazonas (AM)' },
    { value: '14', label: 'Roraima (RR)' },
    { value: '15', label: 'Pará (PA)' },
    { value: '16', label: 'Amapá (AP)' },
    { value: '17', label: 'Tocantins (TO)' },
    { value: '21', label: 'Maranhão (MA)' },
    { value: '22', label: 'Piauí (PI)' },
    { value: '23', label: 'Ceará (CE)' },
    { value: '24', label: 'Rio Grande do Norte (RN)' },
    { value: '25', label: 'Paraíba (PB)' },
    { value: '26', label: 'Pernambuco (PE)' },
    { value: '27', label: 'Alagoas (AL)' },
    { value: '28', label: 'Sergipe (SE)' },
    { value: '29', label: 'Bahia (BA)' },
    { value: '31', label: 'Minas Gerais (MG)' },
    { value: '32', label: 'Espírito Santo (ES)' },
    { value: '33', label: 'Rio de Janeiro (RJ)' },
    { value: '35', label: 'São Paulo (SP)' },
    { value: '41', label: 'Paraná (PR)' },
    { value: '42', label: 'Santa Catarina (SC)' },
    { value: '43', label: 'Rio Grande do Sul (RS)' },
    { value: '50', label: 'Mato Grosso do Sul (MS)' },
    { value: '51', label: 'Mato Grosso (MT)' },
    { value: '52', label: 'Goiás (GO)' },
    { value: '53', label: 'Distrito Federal (DF)' }
  ];

  /* ---------------------------
   STEP 6 — SUCESSO E RESUMO
---------------------------- */
  registeredMember: any = null;
  registeredProperties: any[] = [];

  constructor(
    public http: HttpClient,
    public router: Router,
    public fb: FormBuilder,
    public snackBar: Snackbar,
    public activeModal: NgbActiveModal,
    public memberProvider: MemberProvider,
    public certificateProvider: CertificadoProvider,
    public propertyProvider: PropertyProvider,
    public explorationProvider: ExplorationProvider) { }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this.closeWebSocket();
  }

  /* ================================================================
     STEP 1 — UPLOAD DO CERTIFICADO
  ================================================================= */

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files.length) {
      this.handleFile(input.files[0]);
    }
  }

  onDragOver(evt: DragEvent): void {
    evt.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(): void {
    this.isDragging = false;
  }

  onDrop(evt: DragEvent): void {
    evt.preventDefault();
    this.isDragging = false;

    const file = evt.dataTransfer.files[0];
    if (file) this.handleFile(file);
  }

  handleFile(file: File): void {
    if (!file.name.endsWith('.pfx')) {
      alert('Selecione um arquivo .pfx');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert('Tamanho máximo: 5MB');
      return;
    }

    this.selectedFile = file;

    this.uploadForm.get('file').setValue(file);
    this.uploadForm.get('file').updateValueAndValidity();
  }

  removeFile(): void {
    this.selectedFile = null;

    const fileCtrl = this.uploadForm.get('file');
    const passCtrl = this.uploadForm.get('password');

    if (fileCtrl !== null) {
      fileCtrl.setValue(null);
      fileCtrl.markAsTouched();
      fileCtrl.updateValueAndValidity();
    }

    if (passCtrl !== null) {
      passCtrl.setValue('');
      passCtrl.markAsTouched();
      passCtrl.updateValueAndValidity();
    }
  }


  /* ================================================================
     STEP 2 — PROCESSAR CERTIFICADO
  ================================================================= */

  async processCertificate(): Promise<void> {
    const fileCtrl = this.uploadForm.get('file');
    const passCtrl = this.uploadForm.get('password');

    if (fileCtrl === null || passCtrl === null) return;

    const file = fileCtrl.value;
    const password = passCtrl.value;

    if (!file || !password) return;

    this.isProcessing = true;

    try {
      const base64 = await this.fileToBase64(file);
      this.certificateBase64 = base64;

      const resp = await this.http.post<any>(
        'https://qg6clieecdjdafhsobdpy3wlwu0obnej.lambda-url.sa-east-1.on.aws/',
        { pfx: base64, password: password }
      ).toPromise();

      if (resp === null || resp.sucesso !== true) {
        alert('Erro: ' + (resp.erro || 'Desconhecido'));
        this.isProcessing = false;
        return;
      }

      this.certData = resp.informacoes;
      this.certData.validade_fim = moment(resp.informacoes.validade_fim).format('DD-MM-YYYY - HH:mm:ss');
      this.resetData();
      this.stepper.next();

    } catch (error) {
      this.snackBar.openLong(error.error.status + ' - ' + error.error.erro, 'erro');
    }

    this.isProcessing = false;
  }

  private fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => {
        const buf = r.result as ArrayBuffer;
        const base64 = btoa(String.fromCharCode(...Array.from(new Uint8Array(buf))));
        resolve(base64);
      };
      r.onerror = reject;
      r.readAsArrayBuffer(file);
    });
  }


  /* ================================================================
     STEP 3 — CONSULTAR PROPRIEDADES VIA WEBSOCKET
  ================================================================= */

  startConsultation(): void {
    if (!this.certData) {
      alert('Certificado inválido');
      return;
    }


    const cpfCnpj = this.certData.cpf_cnpj.numero.replace(/\D/g, '');
    // const cpfCnpj = "27259463015";
    const tipoInscrMf = cpfCnpj.length === 11 ? '2' : '1';

    this.logs = [];
    this.progress = 0;
    this.stepper.selectedIndex = 2;
    this.currentMessage = 'Consultando...';
    this.isConsulting = true;

    this.ws$ = webSocket('wss://j9x3sxa9la.execute-api.sa-east-1.amazonaws.com/production/');

    this.ws$.subscribe({
      next: msg => this.handleWSMsg(msg),
      error: err => this.handleWSError(err),
      complete: () => console.log('WS encerrado')
    });

    this.ws$.next({
      action: 'consultar',
      data: {
        cnpj: cpfCnpj,
        cod_uf: this.selectedUf,
        ambiente: '1',
        tipo_inscr_mf: tipoInscrMf,
        use_proxy: true
      },
      headers: {
        Authorization: 'Bearer sk_farmcont_dfe_portal_2024_secure_token_v1'
      }
    });
  }

  private handleWSMsg(msg: any): void {
    if (msg.type === 'progress') {
      this.currentMessage = msg.data.message;
      this.progress = msg.data.progress;
      this.addLog('progress', msg.data.message);
      return;
    }

    if (msg.type === 'error') {
      this.addLog('error', msg.data.message);
      this.isConsulting = false;
      this.closeWebSocket();
      return;
    }

    if (msg.type === 'success') {
      this.addLog('success', 'Consulta finalizada');
      this.isConsulting = false;

      this.consultaResult = msg.data;

      const novas = msg.data.contribuinte.inscricoes_estaduais;
      novas.forEach(ie => {
        if (!this.allProperties.some(x => x.ie === ie.ie)) {
          this.allProperties.push(ie);
        }
      });
      novas.forEach(ie => this.selectedProperties.add(ie.ie));

      this.closeWebSocket();

      this.stepper.next();
    }
  }

  private handleWSError(err: any): void {
    console.error(err);
    this.addLog('error', 'Erro na conexão do WebSocket');
    this.isConsulting = false;
    this.currentMessage = 'Erro na consulta';
  }

  private addLog(type: string, msg: string): void {
    const timestamp = new Date().toLocaleTimeString('pt-BR');
    this.logs.push({ type, message: msg, timestamp });
  }

  private closeWebSocket(): void {
    if (this.ws$) {
      this.ws$.complete();
      this.ws$ = null;
    }
  }

  retryState(): void {
    /** Volta para o Step 3 para consultar outro estado */
    this.stepper.previous();
    this.consultaResult = null;
    this.progress = 0;
    this.currentMessage = 'Aguardando nova consulta...';
  }

  cancelConsultation(): void {
    this.isConsulting = false;
    this.closeWebSocket();
    this.currentMessage = 'Consulta cancelada';
    this.progress = 0;

    this.stepper.selectedIndex = 1; // volta para step 2
  }


  /* ================================================================
     STEP 4 — SELEÇÃO DE PROPRIEDADES
  ================================================================= */

  toggleProperty(ie: string): void {
    if (this.selectedProperties.has(ie))
      this.selectedProperties.delete(ie);
    else
      this.selectedProperties.add(ie);
  }

  toggleSelectAll(): void {
    if (this.allSelectedInCurrentResult()) {
      this.deselectCurrentResult();
    } else {
      this.selectCurrentResult();
    }
  }

  isPropertySelected(ie: string): boolean {
    return this.selectedProperties.has(ie);
  }

  allSelectedInCurrentResult(): boolean {
    if (!this.consultaResult || !this.consultaResult.contribuinte.inscricoes_estaduais.length) {
      return false;
    }
    return this.consultaResult.contribuinte.inscricoes_estaduais.every(
      ie => this.selectedProperties.has(ie.ie)
    );
  }

  selectAllProperties(): void {
    this.allProperties.forEach(p => this.selectedProperties.add(p.ie));
  }

  selectCurrentResult(): void {
    if (!this.consultaResult || !this.consultaResult.contribuinte.inscricoes_estaduais) return;
    this.consultaResult.contribuinte.inscricoes_estaduais.forEach(
      ie => this.selectedProperties.add(ie.ie)
    );
  }

  deselectAllProperties(): void {
    this.selectedProperties.clear();
  }

  deselectCurrentResult(): void {
    if (!this.consultaResult || !this.consultaResult.contribuinte.inscricoes_estaduais) return;
    this.consultaResult.contribuinte.inscricoes_estaduais.forEach(
      ie => this.selectedProperties.delete(ie.ie)
    );
  }

  backToCertInfo(): void {
    this.stepper.selectedIndex = 1;
  }

  get selectedCount(): number {
    return this.selectedProperties.size;
  }

  get toggleAllButtonText(): string {
    return this.allSelectedInCurrentResult() ? 'Desmarcar todos' : 'Marcar todos';
  }

  get toggleAllButtonIcon(): string {
    return this.allSelectedInCurrentResult() ? 'fa-times' : 'fa-check-double';
  }

  prepareFinalization() {
    if (this.selectedCount === 0) this.registerProperties = false;
  }

  /* ================================================================
     STEP 5 - FINALIZAÇÃO
  ================================================================= */

  async submitSimplifiedRegistration() {
    this.loading = true;

    const memberToImport = this.formatMemberToImport();

    try {
      const memberResponse = await this.memberProvider.postMember((memberToImport as any), this.companyId);
      this.snackBar.openLong('Produtor cadastrado com sucesso!', 'success');
      this.registeredMember = memberResponse;
      this.allRegisteredMembers.push(memberResponse);

      await this.importCertificate(memberResponse);

      if (this.registerProperties) {
        await this.importProperties(memberResponse);
      } else {
        this.loading = false;
        this.stepper.next();
      }
    } catch (error) {
      this.loading = false;
      this.snackBar.openLong(error.error.status + ' - ' + error.error.detail, 'erro');
    }
  }

  formatMemberToImport() {

    return {
      name: this.certData.nome,
      cpfCNPJ: this.certData.cpf_cnpj.numero.replace(/\D/g, ''),
      isClient: true
    }
  }

  async importCertificate(memberInfo): Promise<void> {
    const certificateToImport = this.formatCertificateToImport(memberInfo);

    try {
      const certificateResponse = await this.certificateProvider.postCertificado((certificateToImport as any))
      this.snackBar.openLong('Certificado cadastrado com sucesso!', 'success');
    } catch (error) {
      this.loading = false;
      this.snackBar.openLong(error.error.status + ' - ' + error.error.detail, 'erro');
    }
  }

  formatCertificateToImport(memberInfo) {

    return {
      file: this.certificateBase64,
      password: this.uploadForm.get('password').value,
      idCompany: +this.companyId,
      cpfCNPJ: memberInfo.cpfCNPJ,
    }
  }

  getSelectedPropertiesList(): Inscricao[] {
    return this.allProperties.filter(p => this.selectedProperties.has(p.ie));
  }

  getUfLabel(ufCode: string): string {
    const uf = this.ufOptions.find(u => u.value === ufCode);
    return uf ? uf.label.split('(')[1].replace(')', '') : ufCode;
  }

  async importProperties(memberInfo): Promise<void> {
    if (this.selectedCount === 0) {
      alert('Selecione ao menos uma propriedade');
      return;
    }

    const propertiesToImport = this.formatPropertiesToImport();
    console.log("toimport", propertiesToImport)

    try {
      const processPropertySafely = async (property: any, index: number) => {
        try {
          const propertyResponse = await this.propertyProvider.postProperty(property);

          const exploration = {
            cpfCNPJMember: memberInfo.cpfCNPJ,
            companyId: this.companyId,
            propertyCode: property.propertyCode,
            percentage: 100,
            apportionment: true,
            ie: property.ie,
            caepf: '',
            explorationTypeProd: null
          };

          const explorationResponse = await this.explorationProvider.postExploration([exploration]);

          return {
            success: true,
            propertyIndex: index + 1,
            property: propertyResponse,
            exploration: explorationResponse
          };
        } catch (error) {
          return {
            success: false,
            propertyIndex: index + 1,
            error: error.error.detail,
            propertyData: property
          };
        }
      };

      const results = await Promise.all(
        propertiesToImport.map((property, index) =>
          processPropertySafely(property, index)
        )
      );

      this.loading = false;
      const successful = results.filter(r => r.success);
      const failed = results.filter(r => !r.success);

      if (failed.length > 0) {
        console.error('Failed properties:', failed.map(f => f.propertyIndex));
        alert(`Importação parcial: ${successful.length} sucesso, ${failed.length} falhas. Verifique o console.`);
      } else {
        this.snackBar.openLong('Imóveis cadastrados com sucesso!', 'success');
      }

      this.registeredProperties = successful.map(s => ({
        property: s.property,
        exploration: s.exploration[0]
      }));

      this.allRegisteredProperties.push(...this.registeredProperties);
      this.stepper.next();
    } catch (error) {
      this.snackBar.openLong(error.error.status + ' - ' + error.error.detail, 'erro');
    }
  }

  formatPropertiesToImport() {
    const selectedProperties = this.allProperties.filter(
      p => this.selectedProperties.has(p.ie)
    );

    return selectedProperties.map((prop, index) => {
      const endereco = prop.endereco;
      this.globalPropertyCounter++;
      const formattedCode = this.globalPropertyCounter.toString().padStart(3, '0');

      return {
        cep: endereco.cep,
        name: `Propriedade ${this.globalPropertyCounter}`,
        propertyCode: `${formattedCode}`,
        currency: 'BRL',
        itrCode: null,
        neighborhood: endereco.bairro || '',
        street: endereco.logradouro || '',
        countryId: 32,
        companyId: this.companyId,
        cityId: endereco.cod_municipio_ibge || '',
        stateId: prop.uf || '',
        active: true,
        explorationType: "INDIVIDUAL_EXPLORATION",
        ie: prop.ie,
        ...(this.globalPropertyCounter === 1 ? {default: true} : {})
      };
    });
  }

  /* ================================================================
   STEP 6 - RESUMO
================================================================= */

  goToVerification(): void {
    this.activeModal.close('route');
  }

  registerMore(): void {
    this.activeModal.close('register');
  }


  /* ================================================================
     UTILITÁRIOS
  ================================================================= */

  resetData() {
    this.logs = [];
    this.progress = 0;
    this.currentMessage = 'Aguardando...';

    this.allProperties = [];
    this.selectedProperties = new Set<string>();
    this.selectedUf = '43';
    this.registerProperties = true;

    this.registeredMember = null;
    this.registeredProperties = [];

  }

  resetForNewMember() {
    this.selectedFile = null;
    this.certPassword = '';
    this.certificateBase64 = null;
    this.uploadForm.reset();

    this.certData = null;
    this.consultaResult = null;
    this.logs = [];
    this.progress = 0;
    this.currentMessage = 'Aguardando...';

    this.allProperties = [];
    this.selectedProperties = new Set<string>();
    this.selectedUf = '43';
    this.registerProperties = true;

    this.registeredMember = null;
    this.registeredProperties = [];

    this.stepper.selectedIndex = 0;
  }

  getFullAddress(e: any): string {
    if (!e) return '';
    return [e.logradouro, e.numero, e.bairro, e.municipio]
      .filter(Boolean)
      .join(', ');
  }

  formatCpfCnpj(cpfCnpj: string): string {
    if (!cpfCnpj) return '';
    const numbers = cpfCnpj.replace(/\D/g, '');
    if (numbers.length === 11) {
      return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (numbers.length === 14) {
      return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    return cpfCnpj;
  }

  get canProcessCert(): boolean {
    return this.uploadForm
      && this.uploadForm.valid
      && !this.isProcessing;
  }

}

interface CertData {
  nome: string;
  cpf_cnpj: {
    tipo: string;
    numero: string;
  };
  validade_fim: string;
  autoridade_certificadora: string;
}

interface ConsultaResult {
  contribuinte: {
    nome: string;
    cpf_cnpj: string;
    situacao_cpf_cnpj: string;
    inscricoes_estaduais: Inscricao[];
  };
}

interface Inscricao {
  ie: string;
  situacao_ie: string;
  tipo_ie: string;
  cnae_principal: string;
  regime_tributacao: string;
  uf: string;
  endereco?: {
    bairro?: string;
    cep?: string;
    cod_municipio_ibge?: string;
    logradouro?: string;
    municipio?: string;
    numero?: string;
  };
}
